import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { forgotpassword } from "../services/forgotpasswordApi";
import { AuthLayout } from "../components/layout/AuthLayout";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      const response = await forgotpassword(email);

      if (response.data === true) {
        navigate("/otp", { state: { email } });
      } else {
        setError(response.message);
      }
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={
        <>
          Forgot <span className="auth-title__accent">password</span>
        </>
      }
      subtitle="Enter your email to change password."
    >
      {error ? (
        <div className="auth-alert auth-alert--error" role="alert">
          {error}
        </div>
      ) : null}
      {message ? (
        <div className="auth-alert auth-alert--success" role="alert">
          {message}
        </div>
      ) : null}

      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="auth-field">
          <label htmlFor="email" className="auth-field__label">
            Email
            <span className="req">*</span>
          </label>
          <input
            type="email"
            id="email"
            className="auth-field__input"
            placeholder="johndoe@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
        </div>

        <button
          type="submit"
          className={`auth-submit${loading ? " auth-submit--loading" : ""}`}
          disabled={loading}
        >
          {loading ? "Submitting…" : "Submit"}
        </button>
      </form>

      <p className="auth-footer-text">
        <Link to="/signin" className="auth-link">
          Back to sign in
        </Link>
      </p>
    </AuthLayout>
  );
}

export default ForgotPassword;
